"use client";

import React from "react";
import { useTranslations } from "next-intl";
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from "@/components/overlay/alert-dialog";

type PreferencesCorruptionDialogProps = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onKeepRepaired: () => void | Promise<void>;
    onResetToDefaults: () => void | Promise<void>;
};

export function PreferencesCorruptionDialog({
    open,
    onOpenChange,
    onKeepRepaired,
    onResetToDefaults,
}: PreferencesCorruptionDialogProps) {
    const t = useTranslations("ui.preferences_corruption");

    return (
        <AlertDialog open={open} onOpenChange={onOpenChange}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>{t("title")}</AlertDialogTitle>
                    <AlertDialogDescription className="text-left">{t("description")}</AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel
                        onClick={() => {
                            void onKeepRepaired();
                        }}
                    >
                        {t("keep_repaired")}
                    </AlertDialogCancel>
                    <AlertDialogAction
                        onClick={() => {
                            void onResetToDefaults();
                        }}
                    >
                        {t("reset_to_defaults")}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
